import styled from 'styled-components';
import { theme } from 'styled-tools';

import Button from 'Components/Button';

const Backdrop = styled.div`
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
  position: absolute;
  right: 30px;
  top: 30px;
  cursor: pointer;
`;

const Container = styled.main`
  background: #ffffff;
  border-radius: 12px;
  padding: 30px 20px;
  min-width: 300px;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  text-align: center;
  color: #3f465c;
  position: relative;
`;

const Circle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${theme('utils.accentLight')};
  box-shadow: 0px 8.18247px 24.5474px rgb(56 79 117 / 40%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 40px;
  top: -40px;
`;

const CircleIcon = styled.img`
  width: 40px;
  height: 40px;
`;

const ActionButton = styled(Button)`
  margin-top: 70px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  padding: 11px 28px;
  border: none;
  border-radius: 100px;
  width: auto;
  height: auto;
  background: linear-gradient(91.37deg, #ff8d19 3.45%, #fe6708 102.77%);
`;

const Heading = styled.h4`
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.8;
  text-align: center;
  text-transform: uppercase;
  background: ${theme('colors.text.headingColor')};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const WelcomeCTATextWrapper = styled.div`
  width: 192px;
  color: ${theme('colors.text.textColorGreen')};
  font-size: 20px;
  line-height: 180%;
  text-align: center;
  text-transform: uppercase;
`;

const WelcomeCTAText = styled.p`
  font-weight: 500;
`;

const WelcomeCTABoldText = styled.p`
  font-weight: 700;
`;

const WelcomeCTAButtonWrapper = styled.div`
  button {
    margin-top: 168px;
    width: 266px;
    height: 50px;
    background: ${theme('colors.text.textColorGreen')};
    font-size: 18px;
    line-height: 160%;
    text-align: center;
    letter-spacing: 0.02em;
    border: 0;
    color: white;
    border-radius: 100px;
  }
`;

const WelcomeCTALink = styled.div`
  margin-top: 18px;
  font-weight: normal;
  font-size: 18px;
  line-height: 160%;
  text-align: center;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const S = {
  Backdrop,
  CloseIcon,
  Container,
  Circle,
  CircleIcon,
  ActionButton,
  Heading,
  WelcomeCTATextWrapper,
  WelcomeCTAText,
  WelcomeCTABoldText,
  WelcomeCTAButtonWrapper,
  WelcomeCTALink,
};
